import { EmployeeServicePath, VACATIONS } from "utils/constants";
import CorrectVacation from "./Correct";
import permissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: EmployeeServicePath + "correct/" + VACATIONS + "/:id",
  title: "Корекция на отпуск",
  custom: <CorrectVacation />,
  permission: permissions.canCreateLeaveRequests,
};
